export const addNoteModalInitValue = {
  data: {
    date: '',
    text: '',
    modalActionType: '',
    hasBeenModified: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeDate: () => {},
    handleChangeText: () => {},
    handleSaveNote: () => {},
  },
};
